// apps/menu/src/translations/uiTranslations.ts

export const UI_TRANSLATIONS = {
  en: {
    // Labels
    from: 'from ',
    options: 'Options',
    extras: 'Extras',
    addons: 'Addons', 
    allergens: 'Allergens',
    
    // Notice flags
    vegetarian: '🌱 Vegetarian',
    vegan: '🌱 Vegan',
    spicy: '🌶️ Spicy',
    
    // Allergies page UI text
    allergiesTitle: 'Allergy Information',
    allergiesDescription: 'Menu items containing these allergens are marked with the corresponding icons',
    allergiesFooter: 'Please inform your server of any allergies or dietary requirements',
    
    // Footer UI text
    thankYouMessage: 'Thank you for dining with us!',
    followFacebook: 'Follow us on Facebook',
    
    // Home page UI text
    welcomeMessage: 'Welcome to our restaurant! Browse our delicious menu offerings below.',
    loadingMenus: 'Loading menus...',
    errorLoadingMenus: 'Error Loading Menus',
    noMenusAvailable: 'No Menus Available',
    menuUpdatingMessage: "We're currently updating our menu offerings. Please check back soon for our latest delicious options!",
    ourMenus: 'Our Menus',
    viewMenu: 'View Menu'
  },
  es: {
    // Labels
    from: 'desde ',
    options: 'Opciones',
    extras: 'Extras',
    addons: 'Complementos', 
    allergens: 'Alérgenos',
    
    // Notice flags
    vegetarian: '🌱 Vegetariano',
    vegan: '🌱 Vegano',
    spicy: '🌶️ Picante',
    
    // Allergies page UI text
    allergiesTitle: 'Información sobre Alergias',
    allergiesDescription: 'Los elementos del menú que contienen estos alérgenos están marcados con los iconos correspondientes',
    allergiesFooter: 'Informe a su camarero sobre cualquier alergia o requisito dietético',
    
    // Footer UI text
    thankYouMessage: '¡Gracias por cenar con nosotros!',
    followFacebook: 'Síguenos en Facebook',
    
    // Home page UI text
    welcomeMessage: '¡Bienvenido a nuestro restaurante! Explore nuestras deliciosas ofertas de menú a continuación.',
    loadingMenus: 'Cargando menús...',
    errorLoadingMenus: 'Error al Cargar los Menús',
    noMenusAvailable: 'No Hay Menús Disponibles',
    menuUpdatingMessage: 'Actualmente estamos actualizando nuestras ofertas de menú. ¡Vuelve pronto para conocer nuestras últimas opciones deliciosas!',
    ourMenus: 'Nuestros Menús',
    viewMenu: 'Ver Menú'
  },
  de: {
    // Labels
    from: 'ab ',
    options: 'Optionen',
    extras: 'Extras',
    addons: 'Addons', 
    allergens: 'Allergene',
    
    // Notice flags
    vegetarian: '🌱 Vegetarisch',
    vegan: '🌱 Vegan',
    spicy: '🌶️ Scharf',
    
    // Allergies page UI text
    allergiesTitle: 'Allergie-Informationen',
    allergiesDescription: 'Menüpunkte, die diese Allergene enthalten, sind mit den entsprechenden Symbolen gekennzeichnet',
    allergiesFooter: 'Bitte informieren Sie Ihren Kellner über Allergien oder Ernährungsanforderungen',
    
    // Footer UI text
    thankYouMessage: 'Vielen Dank, dass Sie bei uns speisen!',
    followFacebook: 'Folgen Sie uns auf Facebook',
    
    // Home page UI text
    welcomeMessage: 'Willkommen in unserem Restaurant! Stöbern Sie unten in unseren köstlichen Menüangeboten.',
    loadingMenus: 'Menüs werden geladen...',
    errorLoadingMenus: 'Fehler beim Laden der Menüs',
    noMenusAvailable: 'Keine Menüs Verfügbar',
    menuUpdatingMessage: 'Wir aktualisieren derzeit unsere Menüangebote. Schauen Sie bald wieder vorbei für unsere neuesten köstlichen Optionen!',
    ourMenus: 'Unsere Menüs',
    viewMenu: 'Menü Anzeigen'
  },
  nl: {
    // Labels
    from: 'vanaf ',
    options: 'Opties',
    extras: 'Extras',
    addons: 'Addons', 
    allergens: 'Allergenen',
    
    // Notice flags
    vegetarian: '🌱 Vegetarisch',
    vegan: '🌱 Veganistisch',
    spicy: '🌶️ Pittig',
    
    // Allergies page UI text
    allergiesTitle: 'Allergie Informatie',
    allergiesDescription: 'Menu-items die deze allergenen bevatten zijn gemarkeerd met de bijbehorende pictogrammen',
    allergiesFooter: 'Informeer uw bediening over eventuele allergieën of dieetwensen',
    
    // Footer UI text
    thankYouMessage: 'Dank je wel voor het dineren bij ons!',
    followFacebook: 'Volg ons op Facebook',
    
    // Home page UI text
    welcomeMessage: 'Welkom in ons restaurant! Bekijk hieronder onze heerlijke menu-aanbiedingen.',
    loadingMenus: 'Menu\'s laden...',
    errorLoadingMenus: 'Fout bij het Laden van Menu\'s',
    noMenusAvailable: 'Geen Menu\'s Beschikbaar',
    menuUpdatingMessage: 'We zijn momenteel onze menu-aanbiedingen aan het bijwerken. Kom binnenkort terug voor onze nieuwste heerlijke opties!',
    ourMenus: 'Onze Menu\'s',
    viewMenu: 'Bekijk Menu'
  },
  fr: {
    // Labels
    from: 'à partir de ',
    options: 'Options',
    extras: 'Suppléments',
    addons: 'Addons', 
    allergens: 'Allergènes',
    
    // Notice flags
    vegetarian: '🌱 Végétarien',
    vegan: '🌱 Végan',
    spicy: '🌶️ Épicé',
    
    // Allergies page UI text
    allergiesTitle: 'Informations sur les Allergies',
    allergiesDescription: 'Les éléments du menu contenant ces allergènes sont marqués avec les icônes correspondantes',
    allergiesFooter: 'Veuillez informer votre serveur de toute allergie ou exigence alimentaire',
    
    // Footer UI text
    thankYouMessage: 'Merci d\'avoir dîné avec nous!',
    followFacebook: 'Suivez-nous sur Facebook',
    
    // Home page UI text
    welcomeMessage: 'Bienvenue dans notre restaurant! Parcourez nos délicieuses offres de menu ci-dessous.',
    loadingMenus: 'Chargement des menus...',
    errorLoadingMenus: 'Erreur lors du Chargement des Menus',
    noMenusAvailable: 'Aucun Menu Disponible',
    menuUpdatingMessage: 'Nous mettons actuellement à jour nos offres de menu. Revenez bientôt pour nos dernières délicieuses options!',
    ourMenus: 'Nos Menus',
    viewMenu: 'Voir le Menu'
  },
  it: {
    // Labels
    from: 'da ',
    options: 'Opzioni',
    extras: 'Extra',
    addons: 'Addons', 
    allergens: 'Allergeni',
    
    // Notice flags
    vegetarian: '🌱 Vegetariano',
    vegan: '🌱 Vegano',
    spicy: '🌶️ Piccante',
    
    // Allergies page UI text
    allergiesTitle: 'Informazioni sulle Allergie',
    allergiesDescription: 'Gli elementi del menu che contengono questi allergeni sono contrassegnati con le icone corrispondenti',
    allergiesFooter: 'Si prega di informare il cameriere di eventuali allergie o requisiti dietetici',
    
    // Footer UI text
    thankYouMessage: 'Grazie per aver cenato con noi!',
    followFacebook: 'Seguici su Facebook',
    
    // Home page UI text
    welcomeMessage: 'Benvenuti nel nostro ristorante! Sfoglia le nostre deliziose offerte di menu qui sotto.',
    loadingMenus: 'Caricamento menu...',
    errorLoadingMenus: 'Errore nel Caricamento dei Menu',
    noMenusAvailable: 'Nessun Menu Disponibile',
    menuUpdatingMessage: 'Stiamo attualmente aggiornando le nostre offerte di menu. Torna presto per le nostre ultime deliziose opzioni!',
    ourMenus: 'I Nostri Menu',
    viewMenu: 'Visualizza Menu'
  },
  pt: {
    // Labels
    from: 'a partir de ',
    options: 'Opções',
    extras: 'Extras',
    addons: 'Addons', 
    allergens: 'Alérgenos',
    
    // Notice flags
    vegetarian: '🌱 Vegetariano',
    vegan: '🌱 Vegano',
    spicy: '🌶️ Picante',
    
    // Allergies page UI text
    allergiesTitle: 'Informações sobre Alergias',
    allergiesDescription: 'Os itens do menu que contêm estes alérgenos estão marcados com os ícones correspondentes',
    allergiesFooter: 'Por favor, informe o seu garçom sobre quaisquer alergias ou requisitos dietéticos',
    
    // Footer UI text
    thankYouMessage: 'Obrigado por jantar conosco!',
    followFacebook: 'Siga-nos no Facebook',
    
    // Home page UI text
    welcomeMessage: 'Bem-vindos ao nosso restaurante! Navegue pelas nossas deliciosas ofertas de menu abaixo.',
    loadingMenus: 'Carregando menus...',
    errorLoadingMenus: 'Erro ao Carregar Menus',
    noMenusAvailable: 'Nenhum Menu Disponível',
    menuUpdatingMessage: 'Estamos atualmente atualizando nossas ofertas de menu. Volte em breve para nossas últimas opções deliciosas!',
    ourMenus: 'Nossos Menus',
    viewMenu: 'Ver Menu'
  }
};